export const experienceData = [
    
    {
        id: 1,
        company: 'Quickads.ai',
        jobtitle: 'Full Stack Developer',
        startYear: 'Jan 2025',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Polkassembly',
        jobtitle: 'Full Stack Developer',
        startYear: 'Aug 2023',
        endYear: 'Dec 2024'
    },
    {
        id: 3,
        company: 'Testbook.com',
        jobtitle: 'Frontend Developer',
        startYear: 'Feb 2023',
        endYear: 'Aug 2023'
    }
]